<template lang="">
  <slot v-if="msg == undefined || msg.length <= 0"></slot>
<v-tooltip v-else content-class="custom-tooltip" :text="msg" :location="location" style="font-weight: bold; font-size: 25px !important;">
    <template v-slot:activator="{ props }">
      <v-btn
      v-if=icon
        class="button ml-1 mb-1" 
        variant="flat" 
        style="font-size: 9px;border: solid 1px white !important" 
        size="22" 
        v-bind="props" 
        density="compact" 
        icon="mdi-help">
      </v-btn>
      <div v-else v-bind="props" 
      >
        <slot>
        </slot>
      </div>
    </template>
    <template #default>
      <v-col style="color:white;font-size:15px" class="pa-1">
        {{ msg }}
      </v-col>
    </template>
  </v-tooltip>
</template>

<script>
export default {
    props: {
        msg: {},
        location: {
            default: 'top'
        },
        icon:{default:true}
    }
}
</script>

<style>
.custom-tooltip{
    background-color: var(--C1) !important;
    border-radius: 50px !important;
    border: solid 1px white;
}
</style>